// React
import React from 'react';
import {useCallback} from 'react';

// MUI
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import Button from '@mui/material/Button';
import ListItemText from '@mui/material/ListItemText';

// others
import { useAuth } from 'react-oidc-context';

import './App.css';

export default function Settings(props) {
    const auth = useAuth();

    const handleClick = useCallback(
        (e, subSettings) => {
            console.log("event " + e);
            e.stopPropagation();
        },
        []
    );
    
    function renderSubsettingsList() {
        var tempArray = [];
        tempArray.push(
            <ListItemButton key={"Logout"} sx={{position:'relative', height:'40px', lineHeight:'40px', alignContent:'center', borderBottom:'1px solid', borderTop:'1px solid', borderColor:'grey.300'}} onClick={(e) => handleClick(e, null)}>
                <ListItemText primary={"Logout"}/>
            </ListItemButton>
        );
        return tempArray;
    }
    
    return (

        <Box className="Settings" sx={{overflow:'hidden', display:'flex', flexDirection:'row', width:'100%', height:'100%', borderTop:'1px solid', borderColor:'grey.300' }}>
            
            {/* left bar - subsection list */}
            <List sx={{overflow:'auto', width:'20%', height:'100%', borderRight:'1px solid', borderColor:'grey.300'}}>
                {renderSubsettingsList()}
            </List>
            
            {/* right pane - subsection settings */}
            <Box sx={{overflow:'auto', flexGrow:1, height:'100%', borderRight:'1px solid', borderColor:'grey.300'}}>
                <Button onClick={() => auth.signoutRedirect()}>Log out</Button>
            </Box>
            
            
        </Box>
    );
}

